'use strict';

import {Helper} from '../helpers/Helper.js';

export class DonationOrderMetabox {
	#productsName;
	#productTypeSelect;
	#productsByType = {};

	/**
	 * @type {Choices}
	 */
	#productsChoices;


	constructor() {
		this.#productsName = document.getElementById(
			'levcharity_order_product_name'
		);

		this.#productTypeSelect = document.getElementById(
			'levcharity_offline_product_type'
		);

		this.#selectProductTypes();

		this.#watchProductType();
	};


	async #watchProductType() {
		if (!this.#productTypeSelect) {
			return;
		}

		const helper = new Helper();

		await helper.getProductByType(this.#productTypeSelect.value, true)
			.then(response => {
				this.#productsByType[this.#productTypeSelect.value] = {
					timestamp: Helper.strtotime('now'),
					products: response,
				};
				this.#updateProducts(this.#productsByType[this.#productTypeSelect.value]?.products || []);
			});


		this.#productTypeSelect.addEventListener('change', async (event) => {
			if (event.target.value) {
				//Check if products is not saved in the product types object or if saved more 2 minutes ago and then sending the request
				if (typeof this.#productsByType[event.target.value] === "undefined" || Helper.strtotime('now') - this.#productsByType[event.target.value].timestamp > 120) {
					await helper.getProductByType(event.target.value, true)
						.then(response => {
							this.#productsByType[event.target.value] = {
								timestamp: Helper.strtotime('now'),
								products: response,
							};
						})
				}
			} else {
				this.#productsByType = [];
			}

			this.#updateProducts(this.#productsByType[event.target.value]?.products || []);
		});
	}


	#updateProducts(options) {
		this.#productsChoices?.destroy();

		const allOptions = [...this.#productsName.options].map(option => {
			return {
				value: option.value,
				label: option.label
			};
		});

		const placeholder = allOptions.find(o => o.value === '');

		if (placeholder) {
			this.#productsName.innerHTML = `<option value="">${placeholder.label}</option>`;
		}

		options.forEach(option => {
			this.#productsName.innerHTML += `<option value="${option.value}"${this.#productsName.dataset.selected == option.value ? ' selected' : ''}>${option.label}</option>`;
		});

		this.#productsName.dataset.selected = '';

		this.#selectProductNames();
	}

	async #selectProductTypes() {
		if (!this.#productTypeSelect) {
			return;
		}

		await import('../../../node_modules/choices.js/public/assets/scripts/choices.min.js')
		new Choices(this.#productTypeSelect, {
			shouldSortItems: true
		});
	}


	async #selectProductNames() {
		if (!this.#productsName) {
			return;
		}

		const productOptions = {
			shouldSortItems: true
		};


		await import('../../../node_modules/choices.js/public/assets/scripts/choices.min.js')
		this.#productsChoices = new Choices(
			this.#productsName,
			productOptions
		);

	}
}
